import type { NetClient } from './net/NetClient';
import type { PlayerInfo, SpawnAssign } from '../shared/protocol';

export interface SingleSession {
  mode: 'single';
  stageIndex: number;
}

export interface MultiSession {
  mode: 'multi';
  serverUrl: string;
  code: string;
  name: string;
  color: string;
  net: NetClient;
  selfId: string;
  players: PlayerInfo[];
  spawns: SpawnAssign;
  stageIndex: number;
  isHost: boolean;
}

export type Session = SingleSession | MultiSession;

const NAME_KEY = 'slime-brawler:mp-name';
const COLOR_KEY = 'slime-brawler:mp-color';

export function loadName(): string {
  try {
    return window.localStorage.getItem(NAME_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveName(name: string): void {
  try {
    window.localStorage.setItem(NAME_KEY, name);
  } catch {
    return;
  }
}

export function loadColor(fallback: string): string {
  try {
    return window.localStorage.getItem(COLOR_KEY) ?? fallback;
  } catch {
    return fallback;
  }
}

export function saveColor(color: string): void {
  try {
    window.localStorage.setItem(COLOR_KEY, color);
  } catch {
    return;
  }
}

/** URL server multiplayer: env build, atau localhost saat dev. '' = belum dikonfigurasi. */
export function resolveServerUrl(): string {
  const fromEnv = (import.meta.env.VITE_MP_URL as string | undefined ?? '').trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8787';
  return '';
}

/** '#rrggbb' -> number untuk material three. */
export function parseColorHex(hex: string, fallback = 0x5dffd4): number {
  if (/^#[0-9a-fA-F]{6}$/.test(hex)) return parseInt(hex.slice(1), 16);
  return fallback;
}
